import { render } from "./privacy.vue?vue&type=template&id=53ff95d4&scoped=true"
const script = {}

import "./privacy.vue?vue&type=style&index=0&id=53ff95d4&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ff95d4"]])

export default __exports__